import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import {
  Container,
  Card,
  Grid,
  Box,
  Typography,
  CardActions,
  Button,
  Breadcrumbs,
  Modal,
  CardMedia,
} from "@mui/material";

import { instanceToken } from "../../../utils/constant";
import bannerService from "../../../services/bannerService";

const styleR = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const Banner = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [banner, setBanner] = useState(null);
  const [openR, setOpenR] = useState(false);

  useEffect(() => {
    if (!banner) {
      fetchBanner();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchBanner = async () => {
    try {
      const res = await bannerService.getOneBanner(instanceToken.token, id);
      setBanner(res.data);
    } catch (error) {
      console.error(error);

      throw new Error(error);
    }
  };

  if (!banner) {
    return <em>Loading...</em>;
  }

  const handleOpenR = () => setOpenR(true);
  const handleCloseR = () => setOpenR(false);
  const handleRemove = async () => {
    try {
      await bannerService.deleteBanner(instanceToken.token, id);
      homeAlert("Banner post have been removed.", false);
      navigate("/banners");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <>
      <div role="presentation">
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" to="/banners">
            Banners
          </Link>
          <Typography color="text.primary">Banners (ID - {id})</Typography>
        </Breadcrumbs>
      </div>
      <Container
        maxWidth={false}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          mt: 2,
        }}
      >
        <Card
          sx={{
            minWidth: "80vw",
            minHeight: "60vh",
            display: "grid",
            gridTemplateColumns: "2fr 3fr",
          }}
        >
          <div>
            <CardMedia
              component="img"
              height="320"
              image={`${banner.image_url}`}
            />
          </div>
          <Box
            sx={{
              ml: 2,
              p: 2,
              bgcolor: "#f7f7f5",
              borderRadius: 2,
            }}
          >
            {/* Name Eng */}
            <Grid sx={{ m: 2 }} container spacing={2}>
              <Grid item xs={3}>
                <Typography variant="body2" color="text.secondary">
                  Name Eng :
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body2" color="text.secondary">
                  {banner.name_en}
                </Typography>
              </Grid>
            </Grid>

            {/* Name MM */}
            <Grid sx={{ m: 2 }} container spacing={2}>
              <Grid item xs={3}>
                <Typography variant="body2" color="text.secondary">
                  Name MM :
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body2" color="text.secondary">
                  {banner.name_mm}
                </Typography>
              </Grid>
            </Grid>

            <Grid sx={{ m: 2 }} container spacing={2}>
              <Grid item xs={3}>
                <Typography variant="body2" color="text.secondary">
                  Link :
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="body2" color="text.secondary">
                  <a href={banner.link}>{banner.link.substring(0, 10)}</a>
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <CardActions sx={{ gridColumn: "1/3", justifyContent: "end" }}>
            <Button
              sx={{ m: "1rem" }}
              variant="contained"
              color="error"
              onClick={handleOpenR}
            >
              Remove
            </Button>
            <Button
              size="small"
              variant="contained"
              component={Link}
              to={`/updateBanner/${banner.id}`}
            >
              Edit
            </Button>
          </CardActions>
        </Card>
      </Container>
      <Modal
        keepMounted
        open={openR}
        onClose={handleCloseR}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={styleR}>
          <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
            Confirmation
          </Typography>
          <Typography id="keep-mounted-modal-description" sx={{ mt: 2 }}>
            Are you sure want to remove it?
          </Typography>
          <Box sx={{ textAlign: "right", mt: 2 }}>
            <Button color="secondary" onClick={handleCloseR}>
              Cancel
            </Button>
            <Button onClick={handleRemove}>Confirm</Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Banner;
